module.exports = __webpack_public_path__ + "img/logo-1.5681abe1.png";